import { assertTypeMatch } from "@@/utilities/type-helpers";
import type { IsEqual } from "type-fest";
import { z } from "zod";

const smsProviderNames = ["46elks", "test", "twilio"] as const;
const smsProviderNameZodEnum = z.enum(smsProviderNames);
type SmsProviderName = (typeof smsProviderNames)[number];

const testSmsProviderZodObject = z.object({
    name: z.literal("test"),
    settings: z.never().optional(),
});
type TestSmsProvider = z.infer<typeof testSmsProviderZodObject>;
const twilioSmsProviderZodObject = z.object({
    name: z.literal("twilio"),
    settings: z.object({
        // If true we will allow twilio to do a risk check on the message
        riskCheck: z.boolean(),
    }),
});
type TwilioSmsProvider = z.infer<typeof twilioSmsProviderZodObject>;
const elksSmsProviderZodObject = z.object({
    name: z.literal("46elks"),
    settings: z.never().optional(),
});
type ElksSmsProvider = z.infer<typeof elksSmsProviderZodObject>;

const smsProvidersZodObject = z.discriminatedUnion("name", [
    elksSmsProviderZodObject,
    testSmsProviderZodObject,
    twilioSmsProviderZodObject,
]);

type SmsProvider = z.infer<typeof smsProvidersZodObject>;

// Make sure that the SmsProviderName type is always in sync with the smsProvidersZodObject
assertTypeMatch<IsEqual<SmsProviderName, SmsProvider["name"]>>();

export {
    elksSmsProviderZodObject,
    smsProviderNames,
    smsProviderNameZodEnum,
    smsProvidersZodObject,
    testSmsProviderZodObject,
    twilioSmsProviderZodObject,
};
export type {
    ElksSmsProvider,
    SmsProvider,
    SmsProviderName,
    TestSmsProvider,
    TwilioSmsProvider,
};
